var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","width":_vm.size,"height":_vm.size}},[_c('path',{attrs:{"fill":_vm.color,"d":"M9,20.42L2.79,14.21L5.62,11.38L9,14.77L18.88,4.88L21.71,7.71L9,20.42Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }